// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  apiBaseUrl: "https://emoji.maxxsol.com",
  // apiBaseUrl: "https://staging.brewsens.com",
  // apiBaseUrl: "https://222d-103-57-171-246.ngrok-free.app",
  mainContainer: "emoji-dev-storage",
  gameLogos: "game-logos",
  gameMenuArt: "game-menu-art",
  gameMenuLayer: "game-menu-layer",
  inviteImageArt: "invite-image-art",
  sfxSound: "sfx-sound",
  emojis: "emojis",
  prizes: "prizes",
  s3BucketUrl: "https://emoji-dev-storage.s3.us-east-1.amazonaws.com/",
  // s3BucketUrl: "https://emoji-staging-storage.s3.us-east-1.amazonaws.com/",
  resources: "resources",
  categories: "categories",
  powerBarAudioUploadPath: "power-bar-audio",
  powerBarUpload: "power-bar",
  thumbnailUploadPath: "thumbnail",
  imageRulesUploadPath: "image-rules",
  oraganizationUploadPath: "organization-logo",
  surveyUploadPath: "survey-image",
  rewardUploadPath: "reward-image",
  colorWheelPath: "color-wheel",
  googleApiKey: "AIzaSyClMWXHpz_JwjjM0VNIxU5QV3V1Z5bwRL8",
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
